module.exports = __webpack_public_path__ + "img/gb9118_3_h.prt.7fc2a161.jpg";